import React from "react";
import MtgOffers from "./MtgOffers";
import Box from "@mui/material/Box";
import {Typography} from "@mui/material";

export default function MtgAllOffers({cardId, objectType}) {
    return (
        <>
            <Box height={48}/>
            <Typography variant="h4">Oferty</Typography>
            <Box height={24}/>
            <MtgOffers showCardName={true}/>
        </>
    )
}
